import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { fireScheduleConversion } from "@/lib/meta-schedule";
import { InflowHeader } from "@/components/inflow/InflowHeader";
import { InflowFooter } from "@/components/inflow/InflowFooter";
import { BRAND_NAME } from "@/components/inflow/brand";

export const Route = createFileRoute("/thank-you")({
  component: ThankYouPage,
  head: () => ({
    meta: [
      { title: `Application Received | ${BRAND_NAME}` },
      {
        name: "description",
        content:
          "Your application is in. Our USA-based team will call you to confirm the details and see if your clinic is a fit.",
      },
      { property: "og:title", content: `Application Received | ${BRAND_NAME}` },
      {
        property: "og:description",
        content: "Your application is in. Our team will call you shortly.",
      },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

const STEPS = [
  { label: "Watch for our call", detail: "Our USA-based team calls every applicant personally." },
  { label: "Check your phone and email", detail: "Your appointment details are on the way." },
  { label: "Come ready with your numbers", detail: "Care plan pricing and current monthly revenue." },
];

function ThankYouPage() {
  // The calendar redirects here right after a booking is confirmed, so this is
  // the most reliable Schedule signal. Guarded so it only counts once per
  // session even if the in-page calendar message already fired it.
  useEffect(() => {
    fireScheduleConversion();
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans text-foreground">
      <InflowHeader />
      <main className="mx-auto w-full max-w-3xl px-5 pb-16 text-center">
        <h1 className="text-3xl font-extrabold sm:text-4xl">Your application is in.</h1>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          Thanks for applying. Here's what happens next.
        </p>

        <div className="mt-10 grid gap-5 text-left sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <div key={s.label} className="rounded-xl border border-border bg-card p-5">
              <span className="text-2xl font-extrabold tabular-nums text-primary">{i + 1}</span>
              <p className="mt-2 font-semibold">{s.label}</p>
              <p className="mt-1 text-sm text-muted-foreground">{s.detail}</p>
            </div>
          ))}
        </div>
      </main>
      <InflowFooter />
    </div>
  );
}
